<template>
    <div class="jumbotron">
        <div >
            <div class="row">
                <div class="col-sm-8 offset-sm-2">
                    <div>
                        <form
                        id="app"
                        @submit="checkForm"
                        novalidate="true"
                        >

                        <p v-if="errors.length" class="alert alert-danger">
                            <b v-if="errors.length==1">Por favor, corrija el siguiente error:</b>
                            <b v-else>Por favor, corrija los siguientes errores:</b>
                            <ul >
                            <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                            </ul>
                        </p>
                        <p v-if="envio==1" class="alert alert-success">
                            <b>Formulario enviado</b>
                        </p>
                            <div class="form-floating mb-3">
                                <input class="form-control" placeholder="Nombre completo"
                                id="nombre"
                                v-model="nombre"
                                type="text"
                                name="nombre"
                                >
                                <label for="floatingInput">Nombre</label>
                            </div>
                            <div class="form-floating mb-3">
                                <input class="form-control" placeholder="Teléfono"
                                id="telefono"
                                v-model="telefono"
                                type="text"
                                name="telefono"
                                >
                                <label for="floatingInput">Teléfono</label>
                            </div>
                            <div class="form-floating mb-3">
                                <input class="form-control" placeholder="Correo electrónico"
                                id="correo"
                                v-model="correo"
                                type="text"
                                name="correo"
                                >
                                <label for="floatingInput">Correo electrónico</label>
                            </div>
                            <div class="form-floating mb-3">
                                <input class="form-control" placeholder="Asunto"
                                id="asunto"
                                v-model="asunto"
                                type="text"
                                name="asunto"
                                >
                                <label for="floatingInput">Asunto</label>
                            </div>
                            <div class="form-floating">
                                <textarea class="form-control"  v-model="mensaje" name="mensaje" id="mensaje" placeholder="Escriba su mensaje aqui" style="height: 100px"></textarea>
                                <label for="floatingTextarea">Mensaje</label>
                            </div>
                                                
                            <button type="submit" class="btn btn-primary">Enviar Formulario</button>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "contacto",
        data() {
            return {
                errors: [],
                envio:0,
                nombre: null,
                correo: null,
                telefono: null,
                mensaje:null,
                asunto:null,
            }
        },
       
        methods: {
            desaparecerMsj(){
                if(this.envio==1){
                    setTimeout(function() {
                        this.en
                    },1000);
                }
            },
            en(){this.envio=0
            alert('hola')},
            checkForm: function (e) {
                e.preventDefault();
                this.errors = [];

                if (!this.nombre) {
                    this.errors.push("El nombre es obligatorio.");
                    this.envio=0
                }
                if (!this.correo) {
                    this.errors.push('El correo electrónico es obligatorio.');
                    this.envio=0
                } 
                // else if (!this.validEmail(this.correo)) {
                    //     this.errors.push('El correo electrónico debe ser válido.');
                // }
                if (!this.telefono) {
                    this.errors.push("El teléfono es obligatorio.");
                    this.envio=0
                }
                if (!this.asunto) {
                    this.errors.push("El asunto es obligatorio.");
                    this.envio=0
                }
                if (!this.mensaje) {
                    this.errors.push("El mensaje es obligatorio.");
                    this.envio=0
                }
                let me=this;
                if(this.errors.length==0){
                    var url= (process.env.NODE_ENV === 'production' || (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') ? 'https://sistema.empaqueslupa.com' : 'http://127.0.0.1:8000') + '/api/mensaje/formularioContacto';
                    axios.post(url,{
                        'nombre':this.nombre,
                        'telefono':this.telefono,
                        'correo':this.correo,
                        'asunto':this.asunto,
                        'mensaje':this.mensaje
                    }).then(function (response) {
                        if(response.status==200){
                            me.envio=1
                            me.nombre= null
                            me.correo= null
                            me.telefono= null
                            me.mensaje=null
                            me.asunto=null
                        }
                        setTimeout(() => me.envio=0, 1500);
                    })
                    .catch(function () {
                    })

                }
                
                
                
            },
           
           
            // validEmail: function (email) {
            // var re = `/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/`;
            // return re.test(email);
            // }
        },
        mounted(){
            this.desaparecerMsj()
        }
    };
</script>